"use strict";
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
export var container = _7a468({ defaultClassName: "", variantClassNames: { animating: { true: "SlideTransition_container_animating_true__a32upa3" } }, defaultVariants: {}, compoundVariants: [] });
export var panel = "SlideTransition_panel__a32upa4";
export var panelHeight = "var(--panelHeight__a32upa0)";
export var panelWidth = "var(--panelWidth__a32upa1)";
export var slideInLeft = "SlideTransition_slideInLeft__a32upa7";
export var slideInRight = "SlideTransition_slideInRight__a32upa5";
export var slideOutLeft = "SlideTransition_slideOutLeft__a32upa8";
export var slideOutRight = "SlideTransition_slideOutRight__a32upa6";
